import type { HotelPostSearchRule, Tenant } from 'niara-spear-crudmodel';
import React from 'react';
export type HotelSearchContextValue = {
  hotelsPath: string;
  checkoutPath: string;
  cartPath: string;
  addonsPath: string;
  checkoutOrAddonsPath: string;
  engineRuleVersion: '1' | '0';
  isClientUser: boolean;
  b2c: boolean;
  tenant: Tenant | null;
  RoomRateDebugTool?: React.FC<{
    roomRate: any;
  }>;
  showRatePlanName: boolean;
  showRatePlanPublic: boolean;
  realContext?: HotelSearchContextValue;
  showRoomAvailability: HotelPostSearchRule['showRoomAvailabilityConfig_b2c'];
  isLongStay?: boolean;
  isForGroups?: boolean;
};
export const HotelSearchContext = React.createContext<HotelSearchContextValue>({
  b2c: true,
  isClientUser: true,
  checkoutPath: '/checkout',
  engineRuleVersion: '0',
  hotelsPath: '/hotels',
  tenant: null,
  showRatePlanName: false,
  showRatePlanPublic: false,
  cartPath: '/cart',
  showRoomAvailability: 'LESS_THAN_5',
  isLongStay: false,
  isForGroups: false,
  addonsPath: '/addons',
  checkoutOrAddonsPath: '/checkout'
});
export default HotelSearchContext;